import React, { useState } from "react";
import { ArrowRight, Check } from "lucide-react";
import { track } from "../../../lib/analytics";

export const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState("idle"); // idle | loading | done | error
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setMessage("");
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, source_page: window.location.pathname }),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Something went wrong.");
      track("newsletter_signup_submitted", { source_page: window.location.pathname, already: !!data.already });
      setStatus("done");
      setMessage(data.already ? "You're already on the list — thank you!" : "You're in! Check your inbox soon.");
      setEmail("");
    } catch (err) {
      setStatus("error");
      setMessage(err.message || "Something went wrong.");
    }
  };

  return (
    <section data-testid="newsletter" className="bg-brand-bg2">
      <div className="mx-auto max-w-[1100px] px-6 py-24 text-center md:px-10 md:py-28">
        <p className="overline text-brand-inkSoft">Section 06</p>
        <h2 className="mt-3 font-display text-3xl leading-tight text-brand-ink md:text-5xl">Get retreat ideas in your inbox</h2>
        <p className="mx-auto mt-4 max-w-xl text-brand-inkSoft">
          A few times a month: hand-picked escapes, new guides and quiet inspiration. No spam, unsubscribe anytime.
        </p>

        {status === "done" ? (
          <div data-testid="newsletter-success" className="mx-auto mt-8 inline-flex items-center gap-2 rounded-full bg-brand-ink px-6 py-3 text-sm font-medium text-white">
            <Check size={16} /> {message}
          </div>
        ) : (
          <form onSubmit={submit} data-testid="newsletter-form" className="mx-auto mt-8 flex max-w-md flex-col items-stretch gap-3 sm:flex-row">
            <input
              data-testid="newsletter-email"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Email address"
              className="w-full rounded-full border border-brand-line bg-white px-5 py-3.5 text-sm text-brand-ink outline-none focus:border-brand-ink"
            />
            <button
              data-testid="newsletter-submit"
              type="submit"
              disabled={status === "loading"}
              className="inline-flex shrink-0 items-center justify-center gap-2 rounded-full bg-brand-ink px-7 py-3.5 text-sm font-medium text-white transition-colors hover:bg-brand-inkSoft disabled:opacity-60"
            >
              {status === "loading" ? "Joining…" : "Join the list"} <ArrowRight size={15} />
            </button>
          </form>
        )}
        {status === "error" && <p data-testid="newsletter-error" className="mt-4 text-sm text-red-600">{message}</p>}
      </div>
    </section>
  );
};

export default Newsletter;
